<template>
<div class="row">
    <div class="col-md-12 text-center module-card" >
        <div class="blog-entry-sports ">
         <p></p>
            <div class="desc align-text" >
                <h1 class="head-article" v-html="languageData['advSearch']"></h1>
                <div class="side animate-box">
                    <form method="get" action="https://www.google.com/search" class="form-search" target="_blank"> 
                        <label v-html="languageData['searchweb']" for="search_web"></label>
                        <div class=" row form-group">
                            <input type="text" v-model="search_term_google" name="q" class="form-control search form-control-ad-search" id="search_web" maxlength="255" :placeholder="decodeHtmlLang(languageData['search'])" >
                            <button type="submit" aria-label="google search" class="btn submit btn-primary" @click="callSimpleSearch()" v-html="languageData['google']"><i class="icon-search3"></i></button>  
                        </div>
                    </form>                     
                    <br/>
                    <br/>                    
                        <label v-html="languageData['searchtitle']" for="search_title"></label>
                        <div class=" row form-group">
                            <input type="text" v-model="search_term_title" class="form-control search form-control-ad-search" id="search_title" v-bind:placeholder="decodeHtmlLang(languageData['search'])" >
                            <button type="button" aria-label="search_title" class="btn submit btn-primary" @click="callAdvancedSearch()" v-html="languageData['go']"></button>
                            
                        </div>                       
                    <br/>
                    <br/>
                    <label v-html="languageData['searchtext']" for="search_body"></label>
                    <div class=" row form-group">   
                        
                        <input type="text" v-model="search_term_body" class="form-control search form-control-ad-search" id="search_body" :placeholder="decodeHtmlLang(languageData['search'])" >
                        <button aria-label="search_body" type="button" class="btn submit btn-primary" @click="callSimpleSearch()" v-html="languageData['go']"> </button>
             
                    </div>                   
                   
                </div> 
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'advancedSearch',
    data(){
        return{
            main_content:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            search_term:'',
           // languageData:this.$store.state.languageData,
            search_term_title:'',
            search_term_body:'',
            search_term_google:''
        };
        
    },
    mounted :function(){
        this.web_hits();
    },
    computed:{
       languageData(){return this.$store.state.languageData;}
        //searchPlaceholdval() { return this.$refs.bodySrch.innerHTML;}
    },
	methods:{
        callAdvancedSearch(){
            if(this.search_term_title !=''){
                this.$router.push({path:'/search/?q='+this.search_term_title+'&type=advanced'})
            }
        },
        callSimpleSearch(){
            if(this.search_term_body !=''){
                this.$router.push({path:'/search/?q='+this.search_term_body+'&type=simple'})
            }
        }
    }
};
</script>
<style scoped>
.content-top-btm-space{
    padding: 55px 0;
}
/*h2{color: #276d96c7;}*/
.module-card{
    padding: 0 5px 5px 20px;
    text-align: left !important;            
}
.side .category li a {
    border-bottom: 1px solid #e0e0e014;
    display: inline-block !important;
}
.side .category li span{
    font-weight: bold;
}
.search{
    font-size: 14px;
    width: 100%;
    padding-right: 4em;
    border: 1px solid #f0f0f0;
    background: #fff;
    color: #333333 !important;
    font-weight: 300;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    -ms-border-radius: 30px;
    border-radius: 30px;
}
.submit{
    position: absolute;
    top: 0;
    right: -4px;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    border-radius: 0;    
    border: none;
    padding: 18px !important;
    -webkit-border-radius: 30px;
    -moz-border-radius: 30px;
    -ms-border-radius: 30px;
    border-radius: 30px;
}
.btn{
    border:none !important;
}
.align-text {
    text-align: initial;
}
</style>
